import styled from 'styled-components'
import {
	color,
	flexbox,
	grid,
	layout,
	position,
	space,
	system,
	typography,
	borderRadius,
	display,
	overflow,
} from 'styled-system'
import shouldForwardProp from '@styled-system/should-forward-prop'

export const gap = system({ gap: { property: 'gap', scale: 'space' } })

export const Box = styled('div')
	.withConfig({ shouldForwardProp })
	.attrs((props) => ({ display: 'block', position: 'relative', ...props }))(
	{},
	space,
	layout,
	color,
	grid,
	position,
	typography,
	borderRadius,
	display,
	overflow,
)

export const Flex = styled('div')
	.withConfig({ shouldForwardProp })
	.attrs((props) => ({ display: 'flex', position: 'relative', ...props }))(
	{},
	space,
	layout,
	color,
	flexbox,
	grid,
	position,
	gap,
	typography,
	borderRadius,
	display,
	overflow,
)

export const Grid = styled('div')
	.withConfig({ shouldForwardProp })
	.attrs((props) => ({ display: 'grid', position: 'relative', ...props }))(
	{},
	space,
	layout,
	color,
	flexbox,
	grid,
	position,
	gap,
	typography,
	borderRadius,
	display,
	overflow,
)

export const Text = styled('span')
	.attrs((props) => ({ fontSize: 1, textWrap: 'balance', ...props }))
	.withConfig({ shouldForwardProp })({}, typography, space, layout, flexbox, color, grid, position)
